
import { Injectable } from '@angular/core';

import { AgreedUserComponent } from '@components/agreed-user/agreed-user.component';
import { AvailabilityDialogComponent } from '@components/availability-dialog/availability-dialog.component';
import { DocumentReaderDialogComponent } from '@components/document-reader-dialog/document-reader-dialog.component';
import { NominationDialogComponent } from '@components/nomination-dialog/nomination-dialog.component';
//import { ProblemReportComponent } from '@components/problem-report/problem-report.component';

import {
  RoutingOption,
  RoutingSection,
} from '@models/app-router.config';

import { PrimeIcons } from 'primeng/api';
import {
  DialogService,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root',
})
export class VisibilityService {
  private readonly Routings: RoutingSection[] = [
    {
      header: 'Contattaci',
      routings: [
        {
          icon: PrimeIcons.EXCLAMATION_TRIANGLE,
          path: '/problem-report',
          label: 'Richieste o segnalazioni',
          functionalityName: 'problemReport',
        },
        {
          icon: PrimeIcons.PHONE,
          action: () => {
            this.openAvailabilityDialog();
          },
          label: 'Turni reperibilità',
          functionalityName: 'availabilityView',
        },
      ],
    },
    {
      header: 'Statuto e regolamenti',
      routings: [
        {
          icon: PrimeIcons.FILE_PDF,
          action: () => {
            this.openDocumentReaderDialog(
              'Statuto FAISA-CISAL',
              'assets/documents/Statuto-FAISA-CISAL-2024-.pdf',
            );
          },
          label: 'Statuto FAISA-CISAL',
          functionalityName: 'regulationView',
        },
        {
          icon: PrimeIcons.FILE_PDF,
          action: () => {
            this.openDocumentReaderDialog(
              'Regolamento dei collegi dei Probiviri',
              'assets/documents/23.11.2023-Regolamento-collegi-dei-probiviri.pdf',
            );
          },
          label: 'Regolamento dei collegi dei Probiviri',
          functionalityName: 'regulationView',
        },
        {
          icon: PrimeIcons.FILE_PDF,
          action: () => {
            this.openDocumentReaderDialog(
              'CCNL Autoferrotramvieri',
              'assets/documents/Contratto-collettivo-Nazionale-di-lavoro-2015-2017.pdf',
            );
          },
          label: 'CCNL Autoferrotramvieri',
          functionalityName: 'regulationView',
        },
        {
          icon: PrimeIcons.FILE_PDF,
          action: () => {
            this.openDocumentReaderDialog(
              'Rinnovo CCNL Autoferrotramvieri 2024-2026',
              'assets/documents/Rinnovo CCNL Autoferrotramvieri 2024-2026.pdf',
            );
          },
          label: 'Rinnovo CCNL Autoferrotramvieri 2024-2026',
          functionalityName: 'regulationView',
        },
      ],
    },
    {
      header: 'Amministrazione',
      routings: [
        {
          icon: PrimeIcons.EURO,
          path: '/balance',
          label: 'Bilancio',
          functionalityName: 'balanceList',
        },
        {
          icon: PrimeIcons.PHONE,
          path: '/contacts',
          label: 'Area contatti',
          functionalityName: 'contactList',
        },
        {
          icon: PrimeIcons.SIGN_OUT,
          path: '/permissions',
          label: 'Gestione Permessi',
          functionalityName: 'permissionList',
        },
        {
          icon: PrimeIcons.FILE,
          path: '/documents',
          label: 'Protocollazione e documenti',
          functionalityName: 'documentList',
        },
      ],
    },
    {
      header: 'Configurazione',
      routings: [
        {
          icon: PrimeIcons.UNLOCK,
          path: '/authorizations',
          label: 'Autorizzazioni',
          functionalityName: 'authorizationList',
        },
        {
          icon: PrimeIcons.FOLDER_OPEN,
          path: '/regulations',
          label: 'Normative',
          functionalityName: 'regulationList',
        },
      ],
    },
    {
      header: 'Organico',
      routings: [
        {
          icon: PrimeIcons.USERS,
          path: '/subscribers',
          label: 'Gestione iscritti',
          functionalityName: 'subscriberList',
        },
        {
          icon: PrimeIcons.GIFT,
          label: 'Consegne',
          path: '/shippings',
          functionalityName: 'subscriberList',
        },
        {
          icon: PrimeIcons.USER,
          path: '/delegates',
          label: 'Gestione delegati',
          functionalityName: 'delegateList',
        },
        {
          icon: PrimeIcons.SITEMAP,
          path: '/organigram',
          label: 'Organigramma',
          functionalityName: 'organizationChart',
        },
        {
          icon: PrimeIcons.SEARCH,
          action: () => {
            this.openSearchAgreedSubscriber();
          },
          label: 'Ricerca iscritto',
          functionalityName: 'agreedSubscribers',
        },
        {
          icon: PrimeIcons.MEGAPHONE,
          path: '/nominations',
          label: 'Candidature',
          functionalityName: 'nominationList',
        },
      ],
    },
    {
      header: 'Convenzioni',
      routings: [
        {
          icon: PrimeIcons.WALLET,
          path: '/agreements',
          label: 'Gestione convenzioni',
          functionalityName: 'agreementList',
        },
        {
          icon: PrimeIcons.WALLET,
          path: '/agreement-view',
          label: 'Convenzioni',
          functionalityName: 'agreementView',
        },
      ],
    },
    {
      header: 'Votazioni',
      routings: [
        {
          icon: PrimeIcons.BOX,
          path: '/question',
          label: 'Gestione votazioni',
          functionalityName: 'voteListAdmin',
        },
        {
          icon: PrimeIcons.BOX,
          path: '/vote',
          label: 'Vota ora',
          functionalityName: 'voteList',
        },
      ],
    },
    {
      header: 'Area personale',
      routings: [
        {
          icon: PrimeIcons.USER_EDIT,
          path: '/user-info',
          label: 'Area personale',
          functionalityName: 'viewAccount',
        },
        /*{
          icon: PrimeIcons.MEGAPHONE,
          action: () => {
            this.openSubmitNominationDialog();
          },
          label: 'Candidati',
          functionalityName: 'availableNominationList',
        },*/
        {
          icon: PrimeIcons.MEGAPHONE,
          path: '/view-nomination',
          label: 'Candidati',
          functionalityName: 'availableNominationList',
        },
      ],
    },
  ];

  constructor(
    private accountService: AccountService,
    public dialogService: DialogService,
  ) {}

  /*openProblemReport() {
    let dialogRef: DynamicDialogRef = this.dialogService.open(
      ProblemReportComponent,
      {
        maximizable: false,
        draggable: false,
        closable: true,
        closeOnEscape: false,
        header: 'Richieste o segnalazioni',
      },
    );
  }*/

  /* =====================================================
     DIALOG REPERIBILITÀ - STILE AGGIORNATO
     ===================================================== */

  openAvailabilityDialog() {
    let dialogRef: DynamicDialogRef = this.dialogService.open(
      AvailabilityDialogComponent,
      {
        maximizable: false,
        draggable: false,
        closable: true,
        closeOnEscape: false,
        header: 'Reperibilità',
        // Spazio laterale rispetto ai bordi dello schermo.
        width: 'calc(100vw - 40px)',
        // La dialog non diventa eccessivamente larga
        // sui monitor desktop.
        style: {
          'max-width': '900px',
          'max-height': 'calc(100dvh - 40px)',
          'border-radius': '16px',
          overflow: 'hidden',
        },
        // Mantiene accessibile il contenuto
        // quando l'altezza disponibile è ridotta.
        contentStyle: {
          'overflow-y': 'auto',
          'padding': '20px 22px 24px',
        },
      },
    );
  }

  openSubmitNominationDialog() {
    let dialogRef: DynamicDialogRef = this.dialogService.open(
      NominationDialogComponent,
      {
        maximizable: false,
        draggable: false,
        closable: true,
        closeOnEscape: false,
        width: '100%',
        header: 'Candidatura spontanea',
      },
    );
  }

  openSearchAgreedSubscriber() {
    let dialogRef: DynamicDialogRef = this.dialogService.open(
      AgreedUserComponent,
      {
        maximizable: false,
        draggable: false,
        closable: true,
        closeOnEscape: false,
        header: 'Inserisci il codice a 6 caratteri',
      },
    );
  }

  async openDocumentReaderDialog(
    title: string,
    url: string,
  ) {
    let dialogRef: DynamicDialogRef = this.dialogService.open(
      DocumentReaderDialogComponent,
      {
        maximizable: false,
        draggable: false,
        closable: true,
        closeOnEscape: false,
        width: '100%',
        height: '100%',
        header: title,
        data: {
          fileSrc: url,
        },
      },
    );
  }

  getAuthorizedRoutes() {
    return this.Routings.map((section) => {
      let routes: RoutingOption[] = section.routings.filter(
        (route) =>
          this.accountService.group!.authorizations.findIndex(
            (auth) =>
              auth.functionality.name ===
              route.functionalityName,
          ) > -1,
      );

      section.routings = routes;

      return section;
    }).filter(
      (section) => section.routings.length > 0,
    );
  }

  isRouteAuthorized(path: string) {
    let index =
      this.accountService.group?.authorizations.findIndex(
        (auth) => {
          return auth.functionality.path.indexOf(path);
        },
      );

    return (index !== undefined ? index : -1) > -1;
  }
}
